import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: '[mad-sidebar-item]',
  templateUrl: 'sidebar-item.component.html',
  styleUrls: ['sidebar-item.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
})
export class SidebarItemComponent {}
